webpackJsonp([70144966829960],{

/***/ 27:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ExternalLink = function ExternalLink(props) {
	  var size = props.iconSize || 18;
	  var color = props.color;
	
	  var style = _extends({}, props.style);
	  if (color) {
	    style.color = color;
	  }
	  return Glamor.createElement(
	    'a',
	    _extends({ target: '_blank' }, props, { style: style }),
	    Glamor.createElement(
	      'svg',
	      {
	        css: { verticalAlign: 'middle', marginRight: 5 },
	        fill: props.fill || style.color,
	        height: size,
	        viewBox: '0 0 24 24',
	        width: size
	      },
	      Glamor.createElement('path', { d: 'M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z' })
	    ),
	    props.children
	  );
	};
	
	ExternalLink.propTypes = {
	  color: _propTypes2.default.string,
	  fill: _propTypes2.default.string,
	  iconSize: _propTypes2.default.number
	};
	
	exports.default = ExternalLink;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 57:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(11);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Text = __webpack_require__(5);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _colors = __webpack_require__(9);
	
	var _ExternalLink = __webpack_require__(27);
	
	var _ExternalLink2 = _interopRequireDefault(_ExternalLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Contact = function (_React$Component) {
	  _inherits(Contact, _React$Component);
	
	  function Contact(props) {
	    _classCallCheck(this, Contact);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  Contact.prototype.render = function render() {
	    return Glamor.createElement(
	      'div',
	      { className: 'container' },
	      Glamor.createElement(
	        'div',
	        { className: 'row' },
	        Glamor.createElement(
	          'div',
	          {
	            className: 'col',
	            itemScope: true,
	            itemType: 'http://schema.org/Organization'
	          },
	          Glamor.createElement(
	            _Text2.default,
	            {
	              size: 'title',
	              block: true,
	              itemProp: 'address',
	              itemScope: true,
	              itemType: 'http://schema.org/PostalAddress'
	            },
	            'Adresa:'
	          ),
	          Glamor.createElement(
	            _ExternalLink2.default,
	            {
	              href: 'https://maps.google.com/maps?ll=46.778774,23.622164&z=16&t=m&hl=ro-RO&gl=RO&mapclient=embed&cid=5720872781647931140',
	              color: _colors.primaryTextColor
	            },
	            Glamor.createElement(
	              _Text2.default,
	              { size: 'std-large', itemProp: 'streetAddress' },
	              'str Cri\u0219ului nr 9,'
	            ),
	            ' ',
	            Glamor.createElement(
	              _Text2.default,
	              { size: 'std-large', itemProp: 'addressLocality' },
	              'Cluj-Napoca, Rom\xE2nia'
	            )
	          ),
	          Glamor.createElement(
	            _Text2.default,
	            { block: true, size: 'std-large', itemProp: 'name' },
	            'Biserica Cre\u0219tin\u0103 dup\u0103 Evanghelie Cluj-Napoca'
	          ),
	          Glamor.createElement('hr', null)
	        )
	      ),
	      Glamor.createElement(
	        'div',
	        { className: 'row' },
	        Glamor.createElement(
	          'div',
	          { className: 'col' },
	          Glamor.createElement(
	            _Text2.default,
	            { size: 'title', block: true },
	            'Program \xEEnt\xE2lniri:'
	          ),
	          Glamor.createElement(
	            _Text2.default,
	            { size: 'std-large', block: true },
	            'Duminic\u0103: 09:30 - 12:00 \u0219i 18:00 - 20:00'
	          ),
	          Glamor.createElement(
	            _Text2.default,
	            { size: 'std-large', block: true },
	            'Joi: 18:00 - 19:30'
	          ),
	          Glamor.createElement('hr', null)
	        )
	      ),
	      Glamor.createElement(
	        'div',
	        { className: 'row', style: { marginTop: 20 } },
	        Glamor.createElement('iframe', {
	          className: 'col',
	          src: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5464.5914252873345!2d23.617786933252322!3d46.77877715278646!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47490c117db1ea2d%3A0x4f649f7c03536704!2sBiserica+Cre%C8%99tin%C4%83+dup%C4%83+Evanghelie!5e0!3m2!1sro!2sro!4v1504732678153',
	          frameBorder: '0',
	          style: { border: 0, minHeight: 600 },
	          allowFullScreen: true
	        })
	      )
	    );
	  };
	
	  return Contact;
	}(_react2.default.Component);
	
	exports.default = Contact;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-4c60547086e85a0ff954.js